
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[slug]/information",
      function () {
        return require("private-next-pages/category/[slug]/information.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[slug]/information"])
      });
    }
  